export default __webpack_public_path__ + "static/media/221091_squremeasure.3815943e.pdf";